import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedListExternalSystemLogsReq } from 'app/interfaces/requests/Exposed/exposedListExternalSystemLogsReq';
import { ExposedExternalSystemDetailsRes } from 'app/interfaces/responses/Exposed/exposedExternalSystemDetailsRes';
import { ExposedListLogsRes } from 'app/interfaces/responses/Exposed/exposedListLogsRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LogsService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public getExternalSystemDetails(): Observable<ExposedExternalSystemDetailsRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<ExposedExternalSystemDetailsRes>();
        this.http
            .get(environment.localApi + 'ExternalSystemLogs/getExternalSystemDetails/', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<ExposedExternalSystemDetailsRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public getExternalSystemLogs(req: ExposedListExternalSystemLogsReq, showError = true): Observable<Array<ExposedListLogsRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki skjöl');

        let subject = new Subject<Array<ExposedListLogsRes>>();
        this.http
            .post(environment.localApi + 'ExternalSystemLogs/getExternalSystemLogs', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ExposedListLogsRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }
}
